import "./CapitalSolutions.module.css";
import VaultHeader from "@/reusable_sections/Header";
import Funding from "./sections/Funding";
import TheFundingSpectrum from "./sections/TheFundingSpectrum";
import Advantage from "./sections/Advantage";
import VaultFooter from "@/reusable_sections/Footer";
export default function CapitalSolutionsPage() {
  return <div>
      <VaultHeader />
      <Funding />
      <TheFundingSpectrum />
      <Advantage />
      <VaultFooter />
    </div>;
}